import { useSearchParams } from 'react-router-dom';

import { SessionsPage } from '~/components/pages/SessionsPage';
import { PageTemplate } from '~/components/templates/PageTemplate';

export const SessionsRoute: React.FC = () => {
  const [searchParams] = useSearchParams();

  return (
    <PageTemplate>
      <SessionsPage
        previousUrl={searchParams.get('previousUrl') ?? undefined}
        nextUrl={searchParams.get('nextUrl') ?? undefined}
        appRegion={searchParams.get('appRegion') ?? undefined}
      />
    </PageTemplate>
  );
};
